export const TABS = ['Exceptions', 'Activity Log', 'By Department', 'By Entity'] as const;
export type Tab = typeof TABS[number];

export const ACTION_COLORS: Record<string, string> = {
  detected: '#64748b', flagged_for_review: 'var(--warning)', human_approved: 'var(--positive)',
  human_rejected: 'var(--negative)', human_modified: 'var(--navy-600)', escalated: 'var(--navy-800)',
  auto_executed: 'var(--positive)', investigation_started: 'var(--warning)',
  approved_after_investigation: 'var(--positive)', resolution_generated: 'var(--navy-600)',
  resolution_executed: 'var(--navy-700)', je_posted: 'var(--positive)',
  escalated_l2: 'var(--navy-600)', escalated_l3: 'var(--warning)', escalated_l4: '#ea580c',
  escalated_l5: 'var(--negative)', escalated_l6: 'var(--navy-800)', escalated_l7: 'var(--navy-800)',
};

export const TERMINAL_STATUSES = ['approved', 'rejected', 'closed', 'resolved_auto', 'resolved_human', 'dismissed'];

export type WorkloadView = 'all' | 'needs_review' | 'auto_resolved';

export function isAutoResolved(e: any): boolean {
  return (e.status || '').toLowerCase() === 'resolved_auto';
}

export function needsReview(e: any): boolean {
  if (isAutoResolved(e)) return false;
  const st = (e.status || '').toLowerCase();
  return !TERMINAL_STATUSES.includes(st);
}

export function FilterSelect({ value, onChange, options }: { value: string; onChange: (v: string) => void; options: Array<{ value: string; label: string }> }) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)}
      style={{ padding: '7px 10px', background: 'var(--bg-elevated)', border: '1px solid var(--border-default)', borderRadius: 6, color: 'var(--text-primary)', fontSize: 11, outline: 'none' }}>
      {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
    </select>
  );
}

export function Pagination({ page, totalPages, onPage }: { page: number; totalPages: number; onPage: (p: number) => void }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 16 }}>
      <button onClick={() => onPage(Math.max(0, page - 1))} disabled={page === 0}
        style={{ padding: '6px 14px', background: 'var(--bg-card)', border: '1px solid var(--border-default)', borderRadius: 6, color: page === 0 ? 'var(--text-tertiary)' : 'var(--text-primary)', fontSize: 11, fontWeight: 600, cursor: page === 0 ? 'default' : 'pointer' }}>PREV</button>
      <span style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Page {page + 1} of {totalPages}</span>
      <button onClick={() => onPage(Math.min(totalPages - 1, page + 1))} disabled={page >= totalPages - 1}
        style={{ padding: '6px 14px', background: 'var(--bg-card)', border: '1px solid var(--border-default)', borderRadius: 6, color: page >= totalPages - 1 ? 'var(--text-tertiary)' : 'var(--text-primary)', fontSize: 11, fontWeight: 600, cursor: page >= totalPages - 1 ? 'default' : 'pointer' }}>NEXT</button>
    </div>
  );
}

export function DetailRow({ label, value }: { label: string; value: string }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid var(--border-subtle)', fontSize: 12 }}>
      <span style={{ color: 'var(--text-tertiary)' }}>{label}</span>
      <span className="mono" style={{ fontWeight: 600 }}>{value}</span>
    </div>
  );
}
